import Footer from "../../../../content-parts/doc-footer.mdx";
import * as React from 'react';
export default {
  Footer,
  React
};